<template>
  <!-- 面包屑 -->
   <div class="breadcrumb">
    <div @click="goBack" class="breadcrumb-left">
      <img  src="../../assets/image/home/back.png" alt="">
      <span>Back &nbsp|&nbsp Home </span>
      <img  src="../../assets/image/home/right.png" alt="">
    </div> 
    <span>{{ urlName }}</span>
   </div>
 </template>
 
 <script>
 import { mapState } from 'vuex';
 export default {
   name: 'breadcrumb',
   data () {
     return {
     };
   },
   props: {
    urlName: {
      type: String,
      default: ''
    }
   },
   computed: {
     ...mapState({
       isMaxScreen: state => state.isMaxScreen
     })
   },
   methods: {
    goBack(){
      this.$emit("goBack")
    }
   }
 };
 </script>
 
 <style lang="less" scoped>
 .breadcrumb{
  display: flex;
 }

 img{
  width: 20px;
  height: 20px;
 }

 span{
  margin: 0 10px;
 }

 .breadcrumb-left{
  display: flex;
  color: #B2B2B2;
  align-items: center;
  cursor: pointer;
 }
 </style>
 